import React from "react"
import Typography from "aldoo-ra/Typography"
import Input from "aldoo-ra/Input"

const BasicInfoStep = ({ formData, errors, onInputChange }) => {
  // Generate minimum date (current time + 5 minutes)
  const minDate = new Date()
  minDate.setMinutes(minDate.getMinutes() + 5)
  const minDateString = minDate.toISOString().slice(0, 16)


  return (
    <div className="space-y-4">
      <div>
        <Typography  
          variant="admin_label" 
          className="mb-1"
        >
          Release Name <span className="text-admin_error">*</span>
        </Typography>
        
        <input
          type="text"
          value={formData.name}
          onChange={(e) => onInputChange("name", e.target.value)}
          placeholder="Monthly Newsletter - January 2025"
          className={`
            w-full text-admin_text bg-admin_paper rounded-lg border  focus:outline-none focus:ring-1 focus:ring-admin_primary focus:border-transparent px-3 py-2 
            ${errors.name ? "border-admin_error" : "border-admin_bordered"}
          `}
        />

        <div className="h-5 mt-1">
          {errors.name && (
            <Typography 
              variant="admin_txt2" 
              className="text-admin_error"
            >
              {errors.name}
            </Typography>
          )}
        </div>
      </div>
      
      <div>
        <Typography  
          variant="admin_label" 
          className="mb-1"
        >
          Description
        </Typography>

        <textarea
          value={formData.description}
          onChange={(e) => onInputChange("description", e.target.value)}
          placeholder="Brief description of this newsletter release..."
          rows={3}
          className={`
            w-full text-admin_text border border-admin_bordered bg-admin_paper rounded-lg focus:outline-none focus:ring-1 focus:ring-admin_primary focus:border-transparent resize-none px-3 py-2
          `}
        />
      </div>

      <div>
        <Typography  
          variant="admin_label" 
          className="mb-1"
        >
          Scheduled Date & Time <span className="text-admin_error">*</span>
        </Typography>

        <input
          type="datetime-local"
          value={formData.scheduledAt}
          onChange={(e) => onInputChange("scheduledAt", e.target.value)}
          min={minDateString}
          className={`
            w-full text-admin_text bg-admin_paper rounded-lg border focus:outline-none focus:ring-1 focus:ring-admin_primary focus:border-transparent px-3 py-2
            ${errors.scheduledAt ? "border-admin_error" : "border-admin_bordered"}
          `}
        />
        <div className="h-5 mt-1">
          {errors.scheduledAt ? (
            <Typography 
              variant="admin_txt2" 
              className="text-admin_error"
            >
              {errors.scheduledAt}
            </Typography>
          ) : (
            <Typography variant="admin_txt2_dim">
              Must be 5+ minutes ahead
            </Typography>
          )}
        </div>
      </div>
    </div>
  )
}

export default BasicInfoStep